var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-644997c3-9e44-43aa-85b0-3120395987d2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-a8648597-5d34-4054-bcff-2b7261d5e2bd {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-a8648597-5d34-4054-bcff-2b7261d5e2bd",
    d: "M22.41,9.85l-1.02.23s0,0,0,0l-4.73,1.05c-.54.12-.88.65-.76,1.19.12.54.65.88,1.19.76l2.25-.5-3.68,5.45-2.88-3.65-3.96,6.24c-.3.47-.16,1.08.31,1.38.17.11.35.16.53.16.33,0,.66-.16.85-.46l2.44-3.85,2.83,3.59,5.18-7.67.37,2.5c.07.5.5.85.99.85.05,0,.1,0,.15-.01.55-.08.92-.59.84-1.14l-.9-6.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/Trending.d84e5e1282910f9f79322e904a5d2a43.svg";
export { ForwardRef as ReactComponent };